import type { CheckoutConfig } from '#types/config/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    ctas: 'w-full pt-2 fw-bold underlined',
    header: 'fw-bold',
    logo: 'mr-2 shrink-0',
    wrapper: 'max-w-full space-x-1',
  },
  icon: 'chevron'
} satisfies RecursivePartial<CheckoutConfig['loyalty']>
